import {
  ACTIVATE_ADVERTISEMENT_ERROR,
  ACTIVATE_ADVERTISEMENT_START,
  ACTIVATE_ADVERTISEMENT_SUCCESS,
} from 'constants/action-types/communication/activateAdvertisement';

export default (state, { type, payload }) => {
  switch (type) {
    case ACTIVATE_ADVERTISEMENT_START:
      return {
        ...state,
        activateAdvertisement: {
          ...state.activateAdvertisement,
          loading: true,
          message: null,
          error: {},
        },
      };
    case ACTIVATE_ADVERTISEMENT_ERROR:
      return {
        ...state,
        activateAdvertisement: {
          ...state.activateAdvertisement,
          error: payload,
          loading: false,
        },
      };
    case ACTIVATE_ADVERTISEMENT_SUCCESS:
      return {
        ...state,
        activateAdvertisement: {
          ...state.activateAdvertisement,
          message: payload,
          loading: false,
        },
      };
    default:
      return null;
  }
};
